"use client";

import { useContext } from "react";
import { FileManager } from "../core/manager";
import { FileManagerContext } from "./file-manager-store";

export function useFileManager(): FileManager {
	const ctx = useContext(FileManagerContext);

	if (!ctx) {
		throw new Error("FileManager not found");
	}

	return ctx.manager;
}
